// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3cFFL","large":"styles_large__39f7m"};